exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clinic-show-expense .modal-dialog{max-width:768px}", ""]);

// exports
